import React from 'react';
import { getLoggedUser } from '../../../../state/user';
import i18n from '../../../../i18n';
import { getOrganizationList } from '../../../../models/organization';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Dropdown from '../../../common/DropDown';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { apiUrl } from '../../../../constants/global';
import { NavLink } from 'react-router-dom';
import { ClientAmountCard } from '../../../common/ClientAmountCard';
import HeaderBanner from '../../../common/HeaderBanner';
import { Download, FileSpreadsheet, Printer } from 'lucide-react';
import NewDropdown from '../../../common/NewDropDown';
import { downloadFile } from '../../../../utils/downloadFile';
import { DeliveryStatus } from '../../../../constants/status';
import { getDeliveryGroups } from '../AuctionApproval/services/auctionApprovalServices';

const user = getLoggedUser();

const SHARED_STATUSES = ['financeSettled', 'deliveryStarted', 'deliveryCompleted', 'all'];

const allStatuses = [
  { type: 'financeSettled', title: i18n.t('finance_settled'), amount: 0, auctionCount: 0 },
  { type: 'deliveryStarted', title: i18n.t('delivery_started'), amount: 0, auctionCount: 0 },
  { type: 'deliveryCompleted', title: i18n.t('delivery_completed'), amount: 0, auctionCount: 0 },
  { type: 'all', title: i18n.t('all'), amount: 0, auctionCount: 0 },
];
const allowedStatuses = SHARED_STATUSES;
const filteredMeta = allStatuses.filter((card) => allowedStatuses.includes(card.type));

export class DeliveryClearanceList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        client: '',
        startDate: null,
        endDate: null,
      },
      input: {},
      clients: [],
      deliveryGroups: [],
      status: filteredMeta[0]?.type || 'financeSettled',
      activeTab: filteredMeta[0]?.type || 'financeSettled',
      cardMeta: filteredMeta,
      isLoading: false,
      showAddFund: false,
      limit: 15,
      page: 1,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      client: params.get('client') || '',
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
    };
    const status = params.get('status') || 'financeSettled';
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, status, page, limit, activeTab: status }, () => {
      this.getAllOrganization?.();
      this.getDeliveryGroups();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getDeliveryGroups() {
    this.setState({ isLoading: true });
    let { limit, page, status } = this.state;
    let { client, startDate, endDate } = this.state.search;
    const queryStatus = status === 'all' ? null : status;
    const q = {
      page: page,
      limit: limit,
    };
    if (queryStatus) q.status = queryStatus;
    if (client) q.client = client;
    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;

    // Update URL
    this.updateUrlQuery(q);

    let response = await getDeliveryGroups(q);
    if (response.success) {
      let deliveryGroups = response.data;
      let { total, financeSettled, deliveryStarted, deliveryCompleted, all } = response.meta;
      this.setState({
        deliveryGroups,
        total,
        cardMeta: [
          {
            type: 'financeSettled',
            title: i18n.t('finance_settled'),
            amount: financeSettled?.final_bid_amount,
            auctionCount: financeSettled?.auctions_count,
          },
          {
            type: 'deliveryStarted',
            title: i18n.t('delivery_started'),
            amount: deliveryStarted?.final_bid_amount,
            auctionCount: deliveryStarted?.auctions_count,
          },
          {
            type: 'deliveryCompleted',
            title: i18n.t('delivery_completed'),
            amount: deliveryCompleted?.final_bid_amount,
            auctionCount: deliveryCompleted?.auctions_count,
          },
          {
            type: 'all',
            title: i18n.t('all'),
            amount: all?.final_bid_amount,
            auctionCount: all?.auctions_count,
          },
        ].filter((card) => allowedStatuses.includes(card.type)),
        isLoading: false,
      });
    }
    this.setState({ isLoading: false });
  }
  async getAllOrganization() {
    const response = await getOrganizationList();
    let clients = response.data;
    this.setState({ clients });
  }

  getColumns = () => {
    let columns = [
      {
        name: 'Sl No',
        width: '90px',
        sortable: true,
        wrap: true,
        cell: (row, i) => i + 1,
      },
      {
        name: 'ID',
        width: '80px',
        sortable: true,
        wrap: true,
        cell: (row) => row.id,
      },
      {
        minWidth: '130px',
        name: i18n.t('project_code'),
        cell: (row) => <span className="highlight-table-value">{row.project_code}</span>,
      },
      {
        minWidth: '130px',
        name: i18n.t('group_name'),
        cell: (row) => row.group_name,
      },
      {
        name: i18n.t('client'),
        cell: (row) => row.organization_name,
        wrap: true,
      },
      {
        name: i18n.t('auctions'),
        width: '90px',
        cell: (row) => row.auctions_count,
        wrap: true,
        center: true,
      },
      {
        minWidth: '130px',
        name: i18n.t('total_amount'),
        key: 'total_amount',
        cell: (row) => <span className="highlight-table-value">{row.total_amount.toFixed(3)}</span>,
        wrap: true,
        right: true,
      },
      {
        minWidth: '130px',
        name: i18n.t('client_amount'),
        cell: (row) => (
          <span className="highlight-table-value">{row.client_amount.toFixed(3)}</span>
        ),
        wrap: true,
        right: true,
      },
      {
        name: i18n.t('action'),
        wrap: true,
        minWidth: '180px',
        cell: (row) => (
          <div className="action-buttons">
            {getActionButtons(row, this.state.status, user, this)}
          </div>
        ),
      },
    ];

    if (user.role === 'C') {
      columns = columns.filter((col) => col.key !== 'total_amount');
    }

    return columns;
  };

  handleCardSelect = (cardType) => {
    this.setState(
      {
        activeTab: cardType,
        status: cardType,
        page: 1,
      },
      () => {
        this.getDeliveryGroups();
      }
    );
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      const updatedSearch = { ...prevState.search, [name]: value };
      return { search: updatedSearch };
    });
  };

  handleSearch = () => {
    this.getDeliveryGroups();
  };

  handleClear = () => {
    const defaultSearch = {
      client: '',
      startDate: null,
      endDate: null,
      status: this.state.status,
    };

    this.setState({ search: defaultSearch, page: 1 }, () => {
      this.updateUrlQuery({ page: 1, limit: this.state.limit });
      this.getDeliveryGroups();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getDeliveryGroups();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getDeliveryGroups();
    });
  };
  onAddFund = async (group) => {
    this.setState({ showAddFund: true, selectedGroup: group });
  };

  handleDownload = async (fileType) => {
    this.setState({ exportLoading: true });
    const { status, search } = this.state;
    try {
      const params = Object.fromEntries(
        Object.entries({
          client: search.client,
          startDate: search.startDate,
          endDate: search.endDate,
          status: status === 'all' ? null : DeliveryStatus[status],
          fileType,
        }).filter(([_, v]) => v !== null && v !== undefined && v !== '')
      );
      await downloadFile({
        url: `${apiUrl}v2/report/client-payment/groups`,
        params,
        token: user.token,
        fileType,
        fileName: 'Group_Auction_Delivery',
      });
    } finally {
      this.setState({ exportLoading: false });
    }
  };

  handleDownloadAuction = async (fileType) => {
    this.setState({ exportLoading: true });
    const { status, search } = this.state;
    try {
      const params = Object.fromEntries(
        Object.entries({
          client: search.client,
          startDate: search.startDate,
          endDate: search.endDate,
          status: status === 'all' ? null : DeliveryStatus[status],
          fileType,
        }).filter(([_, v]) => v !== null && v !== undefined && v !== '')
      );
      await downloadFile({
        url: `${apiUrl}v2/report/client-payment/groups/auctions`,
        params,
        token: user.token,
        fileType,
        fileName: 'Auction_Delivery',
      });
    } finally {
      this.setState({ exportLoading: false });
    }
  };
  renderListContent() {
    const { clients, deliveryGroups } = this.state;

    return (
      <>
        <div className="client-cards-container-new">
          {this.state.cardMeta.map((config) => (
            <ClientAmountCard
              key={config.type}
              {...config}
              selected={this.state.activeTab === config.type}
              onSelect={this.handleCardSelect}
            />
          ))}
        </div>

        <FilterSection
          loading={this.state.isLoading}
          onSearch={this.handleSearch}
          onClear={this.handleClear}
        >
          {/* Start Date */}
          <div className="select-wrapper floating-label-wrapper">
            <input
              id="startDate"
              type="date"
              name="startDate"
              value={this.state.search.startDate || ''}
              onChange={this.handleSearchChange}
              className="filter-base floating-input"
              placeholder=" "
            />
            <label htmlFor="startDate" className="floating-label">
              {i18n.t('start_date')}
            </label>
          </div>

          {/* End Date */}
          <div className="select-wrapper floating-label-wrapper">
            <input
              id="endDate"
              type="date"
              name="endDate"
              value={this.state.search.endDate || ''}
              onChange={this.handleSearchChange}
              className="filter-base floating-input"
              placeholder={i18n.t('end_date')}
            />
            <label htmlFor="endDate" className="floating-label">
              {i18n.t('end_date')}
            </label>
          </div>

          {/* Client Dropdown */}
          {user.role !== 'C' && (
            <Dropdown
              name="client"
              value={this.state.search.client}
              onChange={this.handleSearchChange}
              placeholder={i18n.t('client_name')}
              empty={i18n.t('select_client')}
              options={clients.map((c) => ({
                value: c.id,
                label: c.organization_name,
              }))}
            />
          )}
        </FilterSection>

        <div className="Data-Listing">
          {this.state.isLoading ? (
            <TableSkeleton columns={10} rows={10} />
          ) : deliveryGroups.length ? (
            <DataTable
              responsive={true}
              columns={this.getColumns()}
              data={deliveryGroups}
              customStyles={tableStyles}
              highlightOnHover
              pagination
              paginationServer
              paginationTotalRows={this.state.total}
              paginationPerPage={this.state.limit}
              paginationDefaultPage={this.state.page}
              paginationRowsPerPageOptions={[15, 25, 50, 100]}
              paginationComponentOptions={{
                rowsPerPageText: i18n.t('rows_per_page'),
                rangeSeparatorText: i18n.t('out'),
              }}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          ) : (
            <NoData
              message={i18n.t('no_data_available')}
              actionText={i18n.t('refresh')}
              onAction={this.getDeliveryGroups.bind(this)}
            />
          )}
        </div>
      </>
    );
  }

  renderExportAction() {
    const { exportLoading } = this.state;

    return (
      <NewDropdown
        label={i18n.t('export')}
        loading={exportLoading}
        icon={Download}
        items={[
          {
            label: i18n.t('excel'),
            icon: FileSpreadsheet,
            onClick: () => this.handleDownload('excel'),
          },
          {
            label: i18n.t('excel_auctions'),
            icon: FileSpreadsheet,
            onClick: () => this.handleDownloadAuction('excel'),
          },
          {
            label: i18n.t('pdf'),
            icon: Printer,
            disabled: true,
          },
        ]}
      />
    );
  }
  render() {
    const { showAddFund, selectedGroup } = this.state;
    const isClientRole = user.role === 'C';

    if (isClientRole) {
      return (
        <React.Fragment>
          <div className="cd-page">
            <div className="cd-shell">
              <p className="cd-crumb">
                <NavLink to="/client-management">{i18n.t('dashboard')}</NavLink>
                <span className="cd-crumb__current">
                  {i18n.t('delivery_clearance')}
                </span>
              </p>

              <header className="cd-hero cd-hero--compact">
                <h1 className="cd-hero__title">{i18n.t('delivery_clearance')}</h1>
                <p className="cd-hero__sub">
                  {i18n.t('track_auction_approval') ||
                    'Track and manage your auction approval requests.'}
                </p>
              </header>

              <div className="card">
                <div className="card-header">
                  <div className="header-action">{this.renderExportAction()}</div>
                </div>
                <div className="card-body">{this.renderListContent()}</div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('delivery_clearance')}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    <div className="header-action">{this.renderExportAction()}</div>
                  </div>
                  <div className="card-body">{this.renderListContent()}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

// Same actions for everyone on all three remaining statuses — just a "view"
// link when the group actually has auctions in it. No more per-role
// branching now that pending/approved/fundAdded/fundDeduct tabs are gone.
const getActionButtons = (row, status, user, ctx) => {
  const buttons = [];
  const hasAuctions = row.auctions.length > 0;
  const detailPath = `/delivery-clearance/${row.id}?status=${ctx.state.status}`;

  if (
    (status === 'financeSettled' || status === 'deliveryStarted' || status === 'deliveryCompleted') &&
    hasAuctions
  ) {
    buttons.push(<ActionButton key="view" label="view" to={detailPath} />);
  }

  return buttons;
};

const ActionButton = ({ label, icon, to, variant = 'button1-primary', onClick }) => {
  if (to) {
    return (
      <NavLink to={to} className={`button1 ${variant} button1-action`}>
        {icon} {i18n.t(label)}
      </NavLink>
    );
  }

  return (
    <button className={`button1 ${variant} button1-action`} onClick={onClick}>
      {icon} {i18n.t(label)}
    </button>
  );
};